import createCargoForm from './createCargoFormModel';
const {
  formField: {
    // DATOS CARGO
    name,
    description,
    area,
    visita_domiciliaria,
    prueba_psicotecnica,
    examen_alimentos,
    examen_alturas,
    certificado_laboral,
    certificado_estudios,
    adres,
    antecedentes_judicial,
    entrevista,
    sociodemografica,
    dme,
    sst,
  },
} = createCargoForm;

export default {
  [name.name]: '',
  [description.name]: '',
  [area.name]: null,
  [visita_domiciliaria.name]: false,
  [prueba_psicotecnica.name]: false,
  [examen_alimentos.name]: false,
  [examen_alturas.name]: false,
  [certificado_laboral.name]: false,
  [certificado_estudios.name]: false,
  [adres.name]: false,
  [antecedentes_judicial.name]: false,
  [entrevista.name]: false,
  [sociodemografica.name]: false,
  [dme.name]: false,
  [sst.name]: false,
};
